module.exports = __webpack_public_path__ + "static/media/bgnav.af66af4e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgnav.gif
// module id = 133
// module chunks = 0